import { useState, forwardRef } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import FormTextField from './FormTextField';

const PasswordField = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false);

  return (
    <FormTextField
      {...props}
      ref={ref}
      type={visible ? 'text' : 'password'}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setVisible(v => !v)}
                tabIndex={-1}
                edge="end"
                size="small"
              >
                {visible ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
});

PasswordField.displayName = 'PasswordField';

export default PasswordField;
